<template>
    <div class="crafting-table">
		<div class="to_app" @click="to_app" ></div>
		<div class="top_arr_data" >
			<div class="top_arr_item" >*{{things_list[0].num}}</div>
			<div class="top_arr_item" >*{{things_list[1].num}}</div>
			<div class="top_arr_item" >*{{things_list[2].num}}</div>
			<div class="top_arr_item" >*{{things_list[3].num}}</div>
		</div>
		<div class="footer_img_5" @click="handle_lottery(5)" >5</div>
		<div class="footer_img_1" @click="handle_lottery(1)" >1</div>
		<div class="footer_img_hecheng" @click="union" >合成</div>
		<div class="footer_text " >
			剩余碎片数: {{num}}个 <div style="display: inline-block;margin-right: 6vw;" ></div> 每日最多可抽取：5次(「画廊周北京」空间内抽取不限次数，且概率更高）
		</div>
		<!-- <div class="footer_text_right" >
每日最多可抽取：5次（「溯」空间内抽取不限次数，且概率更高）
		</div> -->
		<div class="crafting_serve_img"  ></div>
		<div class="crafting_wrap" >
			<div class="crafting_item1" @click="check_item(1)" ></div>
			<div class="crafting_item2" @click="check_item(2)"  ></div>
			<div class="crafting_item3" @click="check_item(3)"  ></div>
			<div class="crafting_item4" @click="check_item(4)"  ></div>
			<div class="crafting_item5" @click="check_item(0)"  ></div>
		</div>
        <!-- <div class="btn-lottery btn-lottery-5" @click="handle_lottery(5)"></div>
        <div class="btn-lottery btn-lottery-1" @click="handle_lottery(1)"></div> -->
        <div class="gou gou1" :class="{ 'gou-show': gouActiveIdx === 0 }" @click="handle_gou(0)"></div>
        <div class="gou gou2" :class="{ 'gou-show': gouActiveIdx === 1 }" @click="handle_gou(1)"></div>
        <div class="gou gou3" :class="{ 'gou-show': gouActiveIdx === 2 }" @click="handle_gou(2)"></div>

        <BaseDialog v-if="dialog.isShow" @submit="triggle_dialog(false)" @close="triggle_dialog(false)">
            <template #content>
                <div class="flex gift-list">
                    <img class="gift" v-for="(item, index) in giftList" :key="index" :src="item.image" alt="大有空间">
                </div>
            </template>
        </BaseDialog>
		
		<div class="crafting_mask flex" v-if="isShow" @click="colse" >
			<img :src="checkList[check_index-1]" alt="">
		</div>
		
    </div>
</template>

<script>
import BaseDialog from '@/components/dialog/baseDialog2/baseDialog'
import { pieceslist , stock , lottery , union , things } from "@/api/craftingTable"
import { toapp } from "@/utils/utils";
export default {
    components: {
        BaseDialog,
    },
    data () {
        return {
            isLoading: false,
            gouActiveIdx: -1,
            giftList: [],
			checkList: [
			    require('@/assets/images/craftingTable/1.png'),
			    require('@/assets/images/craftingTable/2.png'),
			    require('@/assets/images/craftingTable/3.png'),
			    require('@/assets/images/craftingTable/4.png'),
				 require('@/assets/images/craftingTable/5.png'),
			],
			check_index:0,
			stock_data:{
				reserve_num:0,//库存量
				issue_num:0,//发行量
				has_num:0,//当前用户已拥有
			},
			isShow:false,
			things_list:[{num:0},{num:0},{num:0},{num:0}],
            dialog: {
                isShow: false,
            },
			num:0
        }
    },
	mounted() {
		localStorage.setItem('token',this.$route.query.token)
		this.init()
		
	},
    methods: {
        // 抽取
        handle_lottery (count = 1) {
            if (this.isLoading) return
			this.isLoading = true
			this.$toast.loading({
				mask:true,
				duration:15000,
				message: '抽取中...',
			})
			lottery({
				quantity:count
			}).then(res=>{
				this.isLoading = false
				this.$toast.clear()
				this.giftList = res.list
				this.num=res.piece_remain
				this.things()
				this.triggle_dialog(true)
			}).catch(()=>{
				this.isLoading = false
			})
            
        },
		//合成
		union(){
			if(this.stock_data.has_num) return this.$toast('第二只punkcat请前往「画廊周北京」空间获取')
			this.$toast.loading({
				mask:true,
				duration:15000,
				message: '合成中...',
			})
			union({}).then(()=>{
				this.stock_data.has_num=1
				this.num-=3
				this.$toast.clear()
				this.check_item(5)
				this.stock_data.reserve_num--
				
			}).catch(()=>{
				
			})
		},
		init(){//初始化数据
			this.get_data()
			this.stock()
			this.things()
		},
		//已获得的
		things(){
			things({}).then(res=>{
				this.things_list=res.list
			})
		},
		//库存数量
		stock(){
			stock({}).then(res=>{
				this.stock_data=res
			})
		},
		//获取碎片剩余数量
		get_data(){
			pieceslist({}).then(res=>{
				res.list.forEach((item)=>{
					this.num+=item.num
				})
			})
		},
        // 勾选
        handle_gou (index) {
            this.gouActiveIdx = index
        },
		
		colse(){
			this.isShow=false
		},
		
        triggle_dialog (value) {
            this.dialog.isShow = value ? value : !this.dialog.isShow
        },
		
		to_app(){
			toapp(1);
		},
		
		check_item(index){
			if(!index) return
			this.check_index=index
			this.isShow=true
		}
		
    },
}
</script>

<style lang="less" scoped>
@import "./craftingTable.less";
</style>